import { render } from "./AgentConversationDemo.vue?vue&type=template&id=16fa2faa&scoped=true"
import script from "./AgentConversationDemo.vue?vue&type=script&lang=js"
export * from "./AgentConversationDemo.vue?vue&type=script&lang=js"

import "./AgentConversationDemo.vue?vue&type=style&index=0&id=16fa2faa&lang=css"
import "./AgentConversationDemo.vue?vue&type=style&index=1&id=16fa2faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fa2faa"]])

export default __exports__